import { ArrowDownRight, ArrowUpRight, Clock, Eye, Layers, MousePointerClick, Repeat, Star, Users, UtensilsCrossed } from "lucide-react";
import { pick } from "@/lib/format";

export const Change = ({ value, t, testid }) => {
  if (value === null || value === undefined) return <span className="text-[11px] text-muted-foreground" data-testid={testid}>{t("an.noPrev")}</span>;
  const up = value >= 0;
  const Icon = up ? ArrowUpRight : ArrowDownRight;
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-0.5 text-[11px] font-semibold ${up ? "text-emerald-300" : "text-red-300"}`}>
      <Icon className="h-3 w-3 rtl:-scale-x-100" /><bdi>{up ? "+" : ""}{value}%</bdi>
    </span>
  );
};

const Card = ({ icon: Icon, label, value, change, t, testid, sub }) => (
  <div className="rounded-2xl border bg-card p-4" data-testid={testid}>
    <div className="flex items-center justify-between gap-2 text-muted-foreground">
      <span className="text-xs">{label}</span>
      <Icon className="h-4 w-4 text-primary" />
    </div>
    <div className="mt-2 truncate text-2xl font-extrabold tabular-nums" data-testid={`${testid}-value`}>{value}</div>
    <div className="mt-1 truncate text-[11px] text-muted-foreground">{change !== undefined ? <Change value={change} t={t} testid={`${testid}-change`} /> : sub}</div>
  </div>
);

export function SummaryCards({ data, t, lang, catName }) {
  const s = data.summary;
  const c = data.changes;
  const top = data.top_item;
  const cat = data.top_category;
  return (
    <div className="grid grid-cols-2 gap-3 md:grid-cols-4" data-testid="analytics-summary">
      <Card icon={Eye} label={t("an.m.visits")} value={s.visits} change={c.visits} t={t} testid="an-visits" />
      <Card icon={Users} label={t("an.m.unique_visitors")} value={s.unique_visitors} change={c.unique_visitors} t={t} testid="an-unique" />
      <Card icon={MousePointerClick} label={t("an.m.sessions")} value={s.sessions} change={c.sessions} t={t} testid="an-sessions" />
      <Card icon={UtensilsCrossed} label={t("an.m.dish_views")} value={s.dish_views} change={c.dish_views} t={t} testid="an-dish-views" />
      <Card icon={Clock} label={t("an.m.avg_time_s")} value={t("an.seconds", { n: s.avg_time_s })} change={c.avg_time_s} t={t} testid="an-avg-time" />
      <Card icon={Repeat} label={t("an.m.returning")} value={s.returning} change={c.returning} t={t} testid="an-returning" />
      <Card icon={Star} label={t("an.topDish")} value={top ? pick(top, "title", lang).text : "–"} sub={top ? t("an.viewsN", { n: top.views }) : t("an.none")} t={t} testid="an-top-dish" />
      <Card icon={Layers} label={t("an.topCategory")} value={cat ? catName(cat.id) : "–"} sub={cat ? t("an.viewsN", { n: cat.item_views }) : t("an.none")} t={t} testid="an-top-category" />
    </div>
  );
}
